import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from '../../../shared/components/grid-view/grid-view.component';
import { GlobalServices } from '../../services/global.service';
import { MyRequestsService } from '../../services/my-Requests.service';
import { Listing } from '../../models/listing.model';
import { Languages } from '../../models/enums.model';
import { DatePipe } from '@angular/common';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Router } from '@angular/router';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import {enGbLocale} from 'ngx-bootstrap/locale';
import { TranslateService } from '@ngx-translate/core';
import { Status } from '../../models/general.model';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html'
})
export class MyRequestsComponent implements OnInit
{
  private collection: Listing;
  pageSize = 15;
  creationDateFrom: string = "";
  creationDateTo: string = "";
  dateFromFormatted: string = "";
  dateToFormatted: string = "";
  serviceId: string = "";
  serviceStatus: string = "";
  requestNumber: string = "";
  VesselName: string = "";
  public currentLanguage;
  myRequestsLookups: MyRequestsLookups;
  myRequestsStatuses : Status[];
  private itemsMenu: MenuItem[] = [];
  @ViewChild('MyRequests',{static: false}) gridView: GridViewComponent;
  public currentUser: User = new User();
  InvalidDateMessage: string;
  isFromGreaterThanTo = false;
  dateFromCompare: any;
  dateToCompare: any;
  hour: any;

  constructor(private myRequestsService: MyRequestsService, private global: GlobalServices,
              public datepipe: DatePipe, private route: Router, private authenticationService: AuthenticationService,
              private localeService: BsLocaleService,  private translate: TranslateService)
  {
    this.currentUser = this.authenticationService.currentUserValue;
    //this.currentUser = this.global.user;
  }

  async ngOnInit()
  {
    this.global.IsLoaderEnabled = true;
    this.InvalidDateMessage = await this.translate.get('SHARED.InvalidDate').toPromise();
    enGbLocale.invalidDate = this.InvalidDateMessage;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    if(this.currentUser.IsAdmin)
    {
      this.route.navigateByUrl('/workspace');
    }
    else
    {
      this.currentLanguage = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
      this.loadLookups();
    }
    this.global.IsLoaderEnabled = false;
  }

  loadSearchCriteria()
  {
    if(this.global.myRequestsSearchCriteria.length > 0)
    {
      this.creationDateFrom = this.global.myRequestsSearchCriteria[0].creationDateFrom == "" ? "" : this.datepipe.transform(new Date(this.global.myRequestsSearchCriteria[0].creationDateFrom.split('-')[1] + '/' +
                                                               this.global.myRequestsSearchCriteria[0].creationDateFrom.split('-')[0] + '/' +
                                                               this.global.myRequestsSearchCriteria[0].creationDateFrom.split('-')[2]) , 'dd-MM-yyyy');
      this.creationDateTo = this.global.myRequestsSearchCriteria[0].creationDateTo == "" ? "" : this.datepipe.transform(new Date(this.global.myRequestsSearchCriteria[0].creationDateTo.split('-')[1] + '/' +
                                                             this.global.myRequestsSearchCriteria[0].creationDateTo.split('-')[0] + '/' +
                                                             this.global.myRequestsSearchCriteria[0].creationDateTo.split('-')[2]) , 'dd-MM-yyyy');
      this.serviceId = this.global.myRequestsSearchCriteria[0].serviceId;
      this.serviceStatus = this.global.myRequestsSearchCriteria[0].serviceStatus;
      this.requestNumber = this.global.myRequestsSearchCriteria[0].requestNumber;
      this.VesselName = this.global.myRequestsSearchCriteria[0].VesselName;

      this.global.myRequestsSearchCriteria = [];
      this.changeService(this.serviceId, true);
    }
  }

  resetMyRequests()
  {
    this.creationDateFrom = "";
    this.creationDateTo = "";
    this.dateFromFormatted = "";
    this.dateToFormatted = "";
    this.serviceId = "";
    this.serviceStatus = "";
    this.requestNumber = "";
    this.VesselName = "";
    this.loadMyRequests();
  }

  changeService(serviceId, isLoadingSearchCriteria)
  {
    this.myRequestsLookups.Statuses = [];
    if(!isLoadingSearchCriteria)
      this.serviceStatus = "";
    this.myRequestsService.getMyRequestsStatusesLookups(serviceId).subscribe(

      data =>
     // () =>  console.log(data.Data.Statuses),
        this.myRequestsLookups.Statuses = data.Data.Statuses,

       () => console.log("Something went wrong!!"),
      // () => this.loadLookupsCompleted()


    );

  }

  loadMyRequests()
  {
    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;
    this.dateFromCompare = this.creationDateFrom.toString().indexOf("-") > -1 ? new Date(this.datepipe.transform(this.creationDateFrom.split('-')[1] + '/' +  this.creationDateFrom.split('-')[0] + '/' + this.creationDateFrom.split('-')[2]))
                           : new Date(this.creationDateFrom);
    this.dateToCompare = this.creationDateTo.toString().indexOf("-") > -1 ? new Date(this.datepipe.transform(this.creationDateTo.split('-')[1] + '/' +  this.creationDateTo.split('-')[0] + '/' + this.creationDateTo.split('-')[2]))
                           : new Date(this.creationDateTo);
    if(this.dateToCompare < this.dateFromCompare)
    {
      this.isFromGreaterThanTo = true;
    }
    else if(this.creationDateFrom.toString() != this.InvalidDateMessage && this.creationDateTo.toString() != this.InvalidDateMessage)
    {
      this.isFromGreaterThanTo = false;
      this.global.isLoaderEnabled = true;
      this.dateFromFormatted = this.creationDateFrom == "" ? "" : this.creationDateFrom.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.creationDateFrom.split('-')[1] + '/' +
                                                                  this.creationDateFrom.split('-')[0] + '/' + this.creationDateFrom.split('-')[2]) , 'MM/dd/yyyy') :
                                                                  this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      this.dateToFormatted = this.creationDateTo == "" ? "" : this.creationDateTo.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.creationDateTo.split('-')[1] + '/' +
                                                                  this.creationDateTo.split('-')[0] + '/' + this.creationDateTo.split('-')[2]) , 'MM/dd/yyyy') :
                                                                  this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');

      this.global.myRequestsSearchCriteria = [];
      this.global.myRequestsSearchCriteria.push({
        creationDateFrom: this.creationDateFrom == "" ? "" : this.creationDateFrom.toString().indexOf("-") > -1 ? this.creationDateFrom :
                                                             this.datepipe.transform(this.creationDateFrom, 'dd-MM-yyyy'),
        creationDateTo: this.creationDateTo == "" ? "" : this.creationDateTo.toString().indexOf("-") > -1 ? this.creationDateTo :
                                                         this.datepipe.transform(this.creationDateTo, 'dd-MM-yyyy'),
        serviceId: this.serviceId,
        serviceStatus: this.serviceStatus,
        requestNumber: this.requestNumber
      });
      this.myRequestsService.getMyRequests(this.currentUser.UserId, 0, this.pageSize, this.dateFromFormatted, this.dateToFormatted,
                                            this.serviceId, this.serviceStatus, this.requestNumber,this.VesselName).subscribe(
        data => this.collection = data.Data,
        () => console.log("Something went wrong!!"),
        () => this.loadCollectionCompleted(this.dateFromFormatted, this.dateToFormatted)
      );
    }
  }

  loadCollectionCompleted(formattedDateFrom: string, formattedDateTo: string) {
    this.loadItemsMenu();
    this.gridView.loadGrid(this.collection,this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
                          "BaseRequest/GetByRequestorIdPaged?requestorId=" + this.currentUser.UserId +
                          "&pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
                          "&lang=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En") +
                          "&from=" + formattedDateFrom + "&to=" + formattedDateTo + "&serviceId=" + this.serviceId +
                          "&statusId=" + this.serviceStatus + "&reqNumber=" + this.requestNumber,
                          "SHARED.MYREQUESTS", this.itemsMenu, "", "", 'MyRequests');
    this.global.isLoaderEnabled = false;
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
    this.itemsMenu[1].TitleAr = "تاريخ الطلب";
  }

  loadLookups()
  {
    this.myRequestsService.getMyRequestsFilterLookups(this.currentUser.UserId).subscribe(
      data => this.myRequestsLookups = data.Data,
      () => console.log("Something went wrong!!"),
      () => this.loadLookupsCompleted()
      );

  }

  loadLookupsCompleted()
  {
    this.loadSearchCriteria();
    this.loadMyRequests();
  }
}

export class MenuItem {
  Title :string;
  TitleAr :string;
};

export class MyRequestsLookups {
  public Services= [];
  public Statuses=[];
};
